import React, { useState } from 'react'
import { TableCell } from '@mui/material';

import StatusActiveGeneralComponent from '@/main/components/shared/status/statusActiveGeneral';
import { IntegrationCodeResponse } from '@/main/models/response';
import { StatusActiveGeneralEnum } from '@/main/services/enum/StatusActiveGeneralEnum';

import ModalMapCode from '../../modalMapCode/modalMapCode';
import * as S from './styles';

interface IRowDataMappingCodeProps {
  mappingCode: IntegrationCodeResponse;
  updateRowDataGrid: (row: IntegrationCodeResponse) => void;
}
function RowDataMappingCode({
  mappingCode,
  updateRowDataGrid
}: IRowDataMappingCodeProps) {
  const [isOpenModalMapCode, setIsOpenModalMapCode] = useState<boolean>(false)

  function handleClickRow(e: React.MouseEvent<HTMLTableRowElement, MouseEvent>) {
    e.preventDefault();
    e.stopPropagation();
    setIsOpenModalMapCode(true)
  }

  return (
    <>
      <S.Container $isSizeLong onClick={handleClickRow}>
        <TableCell><S.CustomColumn title={mappingCode.code}>{mappingCode.code}</S.CustomColumn></TableCell>
        <TableCell><S.CustomColumn title={mappingCode.description}>{mappingCode.description}</S.CustomColumn></TableCell>
        <TableCell><S.CustomColumn title={mappingCode.interfaceName}>{mappingCode.interfaceName}</S.CustomColumn></TableCell>
        <TableCell><S.CustomColumn title={mappingCode.integrationCodeTypeName}>{mappingCode.integrationCodeTypeName}</ S.CustomColumn></TableCell>
        <TableCell><S.CustomColumn title={mappingCode.companyName}>{mappingCode.companyName}</ S.CustomColumn></TableCell>
        <TableCell><S.CustomColumn><StatusActiveGeneralComponent status={mappingCode.active ? StatusActiveGeneralEnum.Active : StatusActiveGeneralEnum.Inactive} /></S.CustomColumn></TableCell>
      </S.Container>

      <ModalMapCode
        isOpenModal={isOpenModalMapCode}
        setIsOpenModal={setIsOpenModalMapCode}
        guidIntegrationCode={mappingCode.guidIntegrationCode}
        updateRowDataGrid={updateRowDataGrid}
        closeModal={() => setIsOpenModalMapCode(false)}
      />
    </>
  )
}

export default RowDataMappingCode